import { useState } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateMessage, setStateMessage] = useState(null);
    const [name, setName] = useState("");
    const [business, setBusiness] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [content, setContent] = useState("");

    const handleSubmit = (e) => {
        e.persist();
        e.preventDefault();
        setIsSubmitting(true);

        emailjs.sendForm(
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID,
            e.target,
            process.env.REACT_APP_PUBLIC_KEY 
        )
        .then(
            (result) => {
                setStateMessage('Message sent!');
                setIsSubmitting(false);
                setTimeout(() => {
                    setStateMessage(null);
                }, 5000); // hide message after 5 seconds
            },
            (error) => {
                setStateMessage('Something went wrong, please try again later');
                setIsSubmitting(false);
                setTimeout(() => {
                    setStateMessage(null);
                }, 5000); // hide message after 5 seconds
            }
        );
    
        // Clears the form after sending the email
        e.target.reset();
    };

    return (
        <div id="wrap-body">
            <div class="heading-group page-name color-w">
                <h1>Contact</h1>
                <div class="star-group">
                    <i class="fa fa-star-o"></i>
                    <i class="fa fa-star-o star-1x"></i>
                    <i class="fa fa-star-o"></i>
                </div>
            </div>        
            <div class="container" id="main-content">
                <div class="row">
                    <div class="col-md-6">
                        <div class="contact">
                            <div class="addr">
                                <div class="title">Contact
                                    <h3>info</h3></div>
                                <ul class="list-ul">
                                    <li><i class="fa fa-home"></i>322 S. 6th St. Griffin, GA 30224</li>
                                    <li><i class="fa fa-phone"></i>770.233.1159</li>
                                </ul>
                            </div>
                            <form id="contact-form" onSubmit={handleSubmit}>
                                <div class="title">Contact
                                    <h3>form</h3></div>
                                <div id="msg" class="message"></div>
                                <div class="form-group">
                                    <input type="text" class="form-control form-item" id="name" 
                                        value={name} name="name" placeholder="Name"
                                        onChange={(e) => setName(e.target.value)}
                                        />
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control form-item" id="business" 
                                        value={business} name="business" placeholder="Business"
                                        onChange={(e) => setBusiness(e.target.value)}
                                        />
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control form-item" id="phone" 
                                        value={phone} name="phone" placeholder="Phone"
                                        onChange={(e) => setPhone(e.target.value)}
                                        />
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control form-item" id="email" 
                                        value={email} name="email" placeholder="Email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        />
                                </div>
                                <div class="form-group">
                                    <textarea class="form-control form-item" rows="3" id="content" 
                                        value={content} name="content" placeholder="Content"
                                        onChange={(e) => setContent(e.target.value)}
                                        >
                                    </textarea>
                                </div>
                                <input class="btn btn-1" type="submit" value="Send" disabled={isSubmitting} />
                                {stateMessage && <p>{stateMessage}</p>}
                            </form>
                        </div>
                    </div>
                    <div class="col-md-6">
                    <iframe title="googlemap" id="googlemap"src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3336.821286564814!2d-84.2645122238485!3d33.24498505992308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f461db792f9737%3A0xc4bffbc2c0036431!2s322%20S%206th%20St%2C%20Griffin%2C%20GA%2030224!5e0!3m2!1sen!2sus!4v1734898968241!5m2!1sen!2sus" width="540" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>                        
                    </div>
                </div>
            </div>
        </div>
    );


}

export default Contact;